import { Button, TextField, Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { getErrors } from '../util/validation_utilities';
import { signupSchema } from '../Validations/signup_validation';
import axiosInstance from '../util/axios_instance';
import { Helmet } from 'react-helmet-async';

function SignUp() {

    const BACKEND_HOST = process.env.REACT_APP_BACKEND_HOST;
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});

    const [postData, setPostData] = useState(
        {
            firstName: "",
            lastName: "",
            dateOfBirth: "",
            username: "",
            email: "",
            password: ""
        }
    );

    const handleChange = (event) => {
        const { name, value } = event.target;
        setPostData({
            ...postData,
            [name]: value,
        });
    };

    const signUp = async (e) => {
        let response;
        e.preventDefault();
        try {
            await signupSchema.validate(postData, { abortEarly: false })
            setErrors({});
            response = await axiosInstance.post(`${BACKEND_HOST}/user/sign_up`,
                postData,
                {
                    withCredentials: true
                });
            if (response.status === 200) {
                navigate('/login');
            }
        } catch (validationErrors) {
            setErrors(getErrors(validationErrors));
        } finally {
            if (response && response.status === 200) {
                navigate('/login');
            }
        }
    }

    return (
        <div>
            <Helmet>
                <title>Signup - capsuleme.io</title>
                <meta name='description' content='Create an account and write how you you feeling now' />
            </Helmet>
            <form onSubmit={signUp} >
                <Box display="flex"
                    flexDirection={"column"}
                    width="50vw" // Set width to 50% of the viewport width
                    alignItems={'center'}
                    justifyContent={'center'}
                    margin={'auto'}
                    marginTop={5}
                    padding={3}
                    borderRadius={5}
                    boxShadow={"5px 10px 10px #ccc"}
                    sx={{
                        ":hover": {
                            boxShadow: "10px 10px 20px #ccc",
                        }
                    }}>

                    <Typography variant='h2' padding={3} textAlign={'center'}>Sign Up</Typography>
                    <TextField
                        margin='normal'
                        name='firstName'
                        variant='outlined'
                        placeholder='First Name'
                        value={postData.firstName}
                        sx={{ width: '75%' }}
                        onChange={handleChange}>
                    </TextField>
                    {errors.firstName && <div style={{ color: 'red' }}>{errors.firstName}</div>}

                    <TextField
                        margin='normal'
                        variant='outlined'
                        placeholder='Last Name'
                        name='lastName'
                        value={postData.lastName}
                        sx={{ width: '75%' }}
                        onChange={handleChange}>
                    </TextField>
                    {errors.lastName && <div style={{ color: 'red' }}>{errors.lastName}</div>}

                    <TextField
                        margin='normal'
                        variant='outlined'
                        name='dateOfBirth'
                        placeholder='Date Of Birth (yyyy-MM-dd)'
                        value={postData.dateOfBirth}
                        sx={{ width: '75%' }}
                        onChange={handleChange}>
                    </TextField>
                    {errors.dateOfBirth && <div style={{ color: 'red' }}>{errors.dateOfBirth}</div>}

                    <TextField
                        margin='normal'
                        variant='outlined'
                        name='username'
                        placeholder='Username'
                        value={postData.username}
                        sx={{ width: '75%' }}
                        onChange={handleChange}>
                    </TextField>
                    {errors.username && <div style={{ color: 'red' }}>{errors.username}</div>}

                    <TextField
                        margin='normal'
                        type='email'
                        variant='outlined'
                        placeholder='Email'
                        name='email'
                        value={postData.email}
                        sx={{ width: '75%' }}
                        onChange={handleChange}>
                    </TextField>
                    {errors.email && <div style={{ color: 'red' }}>{errors.email}</div>}

                    <TextField
                        margin='normal'
                        type='password'
                        variant='outlined'
                        name='password'
                        placeholder='Password'
                        value={postData.password}
                        sx={{ width: '75%' }}
                        onChange={handleChange}>
                    </TextField>
                    {errors.password && <div style={{ color: 'red' }}>{errors.password}</div>}
                    <Button type='submit' 
                        sx={{
                            marginTop: 3,
                            borderRadius: 1, // squared corners
                            width: '50%'     // take up to 50% of Box width
                        }}
                        variant='contained'>Signup</Button>
                    <Button sx={{ 
                         marginTop: 3,
                            borderRadius: 1, // squared corners
                            width: '50%'    
                     }} onClick={() => { navigate("/login") }}>Login</Button>
                </Box>
            </form>
        </div>
    )
}

export default SignUp;